import React from "react";

// Shared section title: bold sans with the last word in a purple gradient,
// e.g. "Browse by <Category>" — used by every home-page section.
const HeaderTitle = ({ Header }) => {
  const words = (Header || "").trim().split(" ");
  const lastWord = words.pop();
  const leading = words.join(" ");

  return (
    <div className="flex flex-col items-center justify-center my-4 px-4 gap-2">
      <h2
        className="font-black text-center text-gray-900 leading-none tracking-tight"
        style={{ fontSize: "clamp(28px,4.5vw,52px)", letterSpacing: "-0.02em" }}
      >
        {leading && <>{leading} </>}
        <span
          className="bg-clip-text text-transparent"
          style={{ backgroundImage: "linear-gradient(90deg,#8353C6,#9E79D2)" }}
        >
          {lastWord}
        </span>
      </h2>
      {/* Decorative divider */}
      <div className="flex items-center gap-3 mt-1">
        <div className="h-px w-12 bg-gradient-to-r from-transparent to-purple-400" />
        <div className="w-1.5 h-1.5 rotate-45 bg-purple-500" />
        <div className="h-px w-12 bg-gradient-to-l from-transparent to-purple-400" />
      </div>
    </div>
  );
};

export default HeaderTitle;
